var store = {
    state: {
        isLogin: false,
        currentRoute: '',
        currentTab: 0,
        navList: [{
            name: "首頁",
            link: "#home-page"
        }, {
            name: "新聞資訊",
            link: "#page-news"
        }, {
            name: "角色展示",
            link: "#page-role"
        }, {
            name: "遊戲特色",
            link: "#page-game"
        }, {
            name: "儲值中心",
            link: "order"
        }],
    },
}

export default store;